import { useNotificationStore } from '@/stores/NotificationStore'

export const requireOtcGuard = ({ to }) => {
  const { postSideNotification } = useNotificationStore()

  const { otc, error, redirect_url = '' } = to.query

  if (!otc) {
    postSideNotification({ text: error ? `errors.${error}` : 'errors.an_error_occurred_during_sso_authentication', type: 'error', delay: 5000 })

    return redirect_url
  }

  return true
}